<template>
  <svg
    width="65"
    height="64"
    viewBox="0 0 65 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.5 21.5C29.1061 21.5 22.3182 23.5 22.3182 31.5C22.3182 39.5 29.1061 41.5 32.5 41.5C34.9199 41.5 39.0651 40.4833 41.2451 37M37 14.39C35.5486 14.1375 34.0473 14 32.5 14C18.2455 14 7.89394 25.6667 4.5 31.5C8.31818 37.3333 19.2636 49 32.5 49C45.7364 49 56.6818 37.3333 60.5 31.5C59.8874 30.447 59.0481 29.204 58 27.8739"
      stroke="white"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M37.9796 21.8856L52.1319 5.96563C52.7428 5.27842 53.8793 5.71053 53.8793 6.63003V18.3C53.8793 18.8523 54.327 19.3 54.8793 19.3H58.3526C59.2025 19.3 59.665 20.2931 59.118 20.9436L46.5412 35.9005C45.9407 36.6147 44.7759 36.19 44.7759 35.2569V24.55C44.7759 23.9977 44.3281 23.55 43.7759 23.55H38.727C37.8641 23.55 37.4063 22.5305 37.9796 21.8856Z"
      stroke="white"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts"></script>

<style scoped></style>
